import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
  SEARCH_REQUEST_TYPE,
  SEARCH_EQUIPMENT_DELIVERY_ORDER,
  SEARCH_DELIVERY_ORDER_LINE_LOT,
  SEARCH_PRIORITY,
  SEARCH_REQUEST_STATUS,
  SEARCH_REQUEST_TYPE_DETAIL,
  SEARCH_HOSPITAL_SECTION,
  SEARCH_HOSPITAL_SERVICE,
  SEARCH_QUOTE_EXPIRATION,
  SEARCH_INCOTERM,
  SEARCH_TRANSPORT_TYPE,
  SEARCH_FILE_TYPE,
  SEARCH_REQUEST_PROCESS_TYPE,
  SEARCH_REQUEST_ARTICLE_TYPE,
  SEARCH_HEALTH_REGISTRY_AGENCY,
  SEARCH_BMP_AGENCY,
  SEARCH_RISK_TYPE,
  SEARCH_GHTF,
  SEARCH_DIAGNOSTIC_CLASS,
  SEARCH_ISO,
  SEARCH_GT_CERTIFICATE,
  SEARCH_SERVICE_TYPE,
  SEARCH_BIOEQUIVALENCE
} from '../actions';

import {
  SearchRequestTypeSuccess,
  SearchRequestTypeError,
  SearchEquipmentDeliveryOrderSuccess,
  SearchEquipmentDeliveryOrderError,
  SearchDeliveryOrderLineLotSuccess,
  SearchDeliveryOrderLineLotError,
  SearchPrioritySuccess,
  SearchPriorityError,
  SearchRequestStatusSuccess,
  SearchRequestStatusError,
  SearchRequestTypeDetailSuccess,
  SearchRequestTypeDetailError,
  SearchHospitalSectionSuccess,
  SearchHospitalSectionError,
  SearchHospitalServiceSuccess,
  SearchHospitalServiceError,
  SearchQuoteExpirationSuccess,
  SearchQuoteExpirationError,
  SearchIncotermSuccess,
  SearchIncotermError,
  SearchTransportTypeSuccess,
  SearchTransportTypeError,
  SearchFileTypeSuccess,
  SearchFileTypeError,
  SearchRequestProcessTypeSuccess,
  SearchRequestProcessTypeError,
  SearchRequestArticleTypeSuccess,
  SearchRequestArticleTypeError,
  SearchHealthRegistryAgencySuccess,
  SearchHealthRegistryAgencyError,
  SearchBmpAgencySuccess,
  SearchBmpAgencyError,
  SearchRiskTypeSuccess,
  SearchRiskTypeError,
  SearchGhtfSuccess,
  SearchGhtfError,
  SearchDiagnosticClassSuccess,
  SearchDiagnosticClassError,
  SearchIsoSuccess,
  SearchIsoError,
  SearchGtCertificateSuccess,
  SearchGtCertificateError,
  SearchServiceTypeSuccess,
  SearchServiceTypeError,
  SearchBioequivalenceSuccess,
  SearchBioequivalenceError
} from '../actions';


export function* watchSearchRequestType() {
  yield takeEvery(SEARCH_REQUEST_TYPE, onSearchRequestType);
}

export function* watchSearchEquipmentDeliveryOrder() {
  yield takeEvery(SEARCH_EQUIPMENT_DELIVERY_ORDER, onSearchEquipmentDeliveryOrder);
}

export function* watchSearchDeliveryOrderLineLot() {
  yield takeEvery(SEARCH_DELIVERY_ORDER_LINE_LOT, onSearchDeliveryOrderLineLot);
}

export function* watchSearchPriority() {
  yield takeEvery(SEARCH_PRIORITY, onSearchPriority);
}

export function* watchSearchRequestStatus() {
  yield takeEvery(SEARCH_REQUEST_STATUS, onSearchRequestStatus);
}

export function* watchSearchRequestTypeDetail() {
  yield takeEvery(SEARCH_REQUEST_TYPE_DETAIL, onSearchRequestTypeDetail);
}

export function* watchSearchHospitalSection() {
  yield takeEvery(SEARCH_HOSPITAL_SECTION, onSearchHospitalSection);
}

export function* watchSearchHospitalService() {
  yield takeEvery(SEARCH_HOSPITAL_SERVICE, onSearchHospitalService);
}

export function* watchSearchQuoteExpiration() {
  yield takeEvery(SEARCH_QUOTE_EXPIRATION, onSearchQuoteExpiration);
}

export function* watchSearchIncoterm() {
  yield takeEvery(SEARCH_INCOTERM, onSearchIncoterm);
}

export function* watchSearchTransportType() {
  yield takeEvery(SEARCH_TRANSPORT_TYPE, onSearchTransportType);
}

export function* watchSearchFileType() {
  yield takeEvery(SEARCH_FILE_TYPE, onSearchFileType);
}

export function* watchSearchRequestProcessType() {
  yield takeEvery(SEARCH_REQUEST_PROCESS_TYPE, onSearchRequestProcessType);
}

export function* watchSearchRequestArticleType() {
  yield takeEvery(SEARCH_REQUEST_ARTICLE_TYPE, onSearchRequestArticleType);
}

export function* watchSearchHealthRegistryAgency() {
  yield takeEvery(SEARCH_HEALTH_REGISTRY_AGENCY, onSearchHealthRegistryAgency);
}

export function* watchSearchBmpAgency() {
  yield takeEvery(SEARCH_BMP_AGENCY, onSearchBmpAgency);
}

export function* watchSearchRiskType() {
  yield takeEvery(SEARCH_RISK_TYPE, onSearchRiskType);
}

export function* watchSearchGhtf() {
  yield takeEvery(SEARCH_GHTF, onSearchGhtf);
}

export function* watchSearchDiagnosticClass() {
  yield takeEvery(SEARCH_DIAGNOSTIC_CLASS, onSearchDiagnosticClass);
}

export function* watchSearchIso() {
  yield takeEvery(SEARCH_ISO, onSearchIso);
}

export function* watchSearchGtCertificate() {
  yield takeEvery(SEARCH_GT_CERTIFICATE, onSearchGtCertificate);
}

export function* watchSearchServiceType() {
  yield takeEvery(SEARCH_SERVICE_TYPE, onSearchServiceType);
}

export function* watchSearchBioequivalence() {
  yield takeEvery(SEARCH_BIOEQUIVALENCE, onSearchBioequivalence);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onSearchRequestTypeAsync = async (payload) => { 
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())   
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchEquipmentDeliveryOrderAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/equipment_delivery_order', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ; 
};

const onSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchPriorityAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/priority', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRequestStatusAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_status', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};


const onSearchRequestTypeDetailAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_type_detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json' , 'token': token },
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchHospitalSectionAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/hospital_section', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchHospitalServiceAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/hospital_service', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchQuoteExpirationAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/quote_expiration', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchIncotermAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/incoterm', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchTransportTypeAsync = async () => {
  const response = await fetch(servicePath + 'search/transport_type', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json'}
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchFileTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/file_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRequestProcessTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_process_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRequestArticleTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request_article_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchHealthRegistryAgencyAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/health_registry_agency', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchBmpAgencyAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/bmp_agency', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchRiskTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/risk_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchGhtfAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/ghtf', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchDiagnosticClassAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/diagnostic_class', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchIsoAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/iso', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchGtCertificateAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/gt_certificate', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchServiceTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/service_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchBioequivalenceAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/bioequivalence', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

function* onSearchRequestType(data) {
  try {
    const response = yield call(onSearchRequestTypeAsync, data.payload);
    yield put(SearchRequestTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestTypeError(error));
  }
}

function* onSearchEquipmentDeliveryOrder(data) {
  try {
    const response = yield call(onSearchEquipmentDeliveryOrderAsync, data.payload);
    yield put(SearchEquipmentDeliveryOrderSuccess(response.data));
  } catch (error) {
    yield put(SearchEquipmentDeliveryOrderError(error));
  }
}

function* onSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(SearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(SearchDeliveryOrderLineLotError(error));
  }
}

function* onSearchPriority(data) {
  try {
    const response = yield call(onSearchPriorityAsync, data.payload);
    yield put(SearchPrioritySuccess(response.data));
  } catch (error) {
    yield put(SearchPriorityError(error));
  }
}

function* onSearchRequestStatus(data) { 
  try {
    const response = yield call(onSearchRequestStatusAsync, data.payload);
    yield put(SearchRequestStatusSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestStatusError(error));
  }
}

function* onSearchRequestTypeDetail(data) {
  try {
    const response = yield call(onSearchRequestTypeDetailAsync, data);
    yield put(SearchRequestTypeDetailSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestTypeDetailError(error));
  }
}

function* onSearchHospitalSection(data) {
  try {
    const response = yield call(onSearchHospitalSectionAsync, data.payload);
    yield put(SearchHospitalSectionSuccess(response.data));
  } catch (error) {
    yield put(SearchHospitalSectionError(error));
  }
}

function* onSearchHospitalService(data) {
  try {
    const response = yield call(onSearchHospitalServiceAsync, data);
    yield put(SearchHospitalServiceSuccess(response.data));
  } catch (error) {
    yield put(SearchHospitalServiceError(error));
  }
}

function* onSearchQuoteExpiration(data) {
  try {
    const response = yield call(onSearchQuoteExpirationAsync, data);
    yield put(SearchQuoteExpirationSuccess(response.data));
  } catch (error) {
    yield put(SearchQuoteExpirationError(error));
  }
}

function* onSearchIncoterm(data) {
  try {
    const response = yield call(onSearchIncotermAsync, data);
    yield put(SearchIncotermSuccess(response.data));
  } catch (error) {
    yield put(SearchIncotermError(error));
  }
}

function* onSearchTransportType(data) {
  try {
    const response = yield call(onSearchTransportTypeAsync, data);
    yield put(SearchTransportTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchTransportTypeError(error));
  }
}

function* onSearchFileType(data) {
  try {
    const response = yield call(onSearchFileTypeAsync, data.payload);
    yield put(SearchFileTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchFileTypeError(error));
  }
}

function* onSearchRequestProcessType(data) {
  try {
    const response = yield call(onSearchRequestProcessTypeAsync, data.payload);
    yield put(SearchRequestProcessTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestProcessTypeError(error));
  }
}

function* onSearchRequestArticleType(data) {
  try {
    const response = yield call(onSearchRequestArticleTypeAsync, data.payload);
    yield put(SearchRequestArticleTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchRequestArticleTypeError(error));
  }
}

function* onSearchHealthRegistryAgency(data) {
  try {
    const response = yield call(onSearchHealthRegistryAgencyAsync, data.payload);
    yield put(SearchHealthRegistryAgencySuccess(response.data));
  } catch (error) {
    yield put(SearchHealthRegistryAgencyError(error));
  }
}

function* onSearchBmpAgency(data) {
  try {
    const response = yield call(onSearchBmpAgencyAsync, data.payload);
    yield put(SearchBmpAgencySuccess(response.data));
  } catch (error) {
    yield put(SearchBmpAgencyError(error));
  }
}

function* onSearchRiskType(data) {
  try {
    const response = yield call(onSearchRiskTypeAsync, data.payload);
    yield put(SearchRiskTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchRiskTypeError(error));
  }
}

function* onSearchGhtf(data) {
  try {
    const response = yield call(onSearchGhtfAsync, data.payload);
    yield put(SearchGhtfSuccess(response.data));
  } catch (error) {
    yield put(SearchGhtfError(error));
  }
}

function* onSearchDiagnosticClass(data) {
  try {
    const response = yield call(onSearchDiagnosticClassAsync, data.payload);
    yield put(SearchDiagnosticClassSuccess(response.data));
  } catch (error) {
    yield put(SearchDiagnosticClassError(error));
  }
}

function* onSearchIso(data) {
  try {
    const response = yield call(onSearchIsoAsync, data.payload);
    yield put(SearchIsoSuccess(response.data));
  } catch (error) {
    yield put(SearchIsoError(error));
  }
}

function* onSearchGtCertificate(data) {
  try {
    const response = yield call(onSearchGtCertificateAsync, data.payload);
    yield put(SearchGtCertificateSuccess(response.data));
  } catch (error) {
    yield put(SearchGtCertificateError(error));
  }
}

function* onSearchServiceType(data) {
  try {
    const response = yield call(onSearchServiceTypeAsync, data.payload);
    yield put(SearchServiceTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchServiceTypeError(error));
  }
}

function* onSearchBioequivalence(data) {
  try {
    const response = yield call(onSearchBioequivalenceAsync, data.payload);
    yield put(SearchBioequivalenceSuccess(response.data));
  } catch (error) {
    yield put(SearchBioequivalenceError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchSearchRequestType),
    fork(watchSearchEquipmentDeliveryOrder),
    fork(watchSearchRequestStatus),
    fork(watchSearchRequestTypeDetail),
    fork(watchSearchHospitalSection),
    fork(watchSearchHospitalService),
    fork(watchSearchQuoteExpiration),
    fork(watchSearchIncoterm),
    fork(watchSearchTransportType),
    fork(watchSearchFileType),
    fork(watchSearchRequestProcessType),
    fork(watchSearchRequestArticleType),
    fork(watchSearchHealthRegistryAgency),
    fork(watchSearchBmpAgency),
    fork(watchSearchRiskType),
    fork(watchSearchGhtf),
    fork(watchSearchDiagnosticClass),
    fork(watchSearchIso),
    fork(watchSearchGtCertificate),
    fork(watchSearchServiceType),
    fork(watchSearchDeliveryOrderLineLot),
    fork(watchSearchPriority),
    fork(watchSearchBioequivalence)
  ]);
}